import React, { Component, PropTypes } from 'react';
import { Dialog } from 'components/Dialog';
import FileSelectorContainer from 'containers/MediaLibrary/FileSelectorContainer';
import { Toolbar, TabButton } from 'components/Toolbar';
import FileUploader from './FileUploader';

const css = oxygenCss({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 64,
    bottom: 0
  }
});

class UploadDialog extends Component {
  static propTypes = {
    title: PropTypes.node,
    accept: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    onSuccess: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    mode: 'upload'
  };

  uploadMode = () => {
    this.setState({ mode: 'upload' });
  };

  libraryMode = () => {
    this.setState({ mode: 'library' });
  };

  uploadSuccess = files => {
    if (files && files.length > 0) {
      const { onSuccess } = this.props;
      if (onSuccess) {
        files.forEach(record => {
          const { file } = record;
          const { url, id } = file;
          onSuccess(url, id);
        });
      }
    }
  };

  selectFile = file => {
    const { url, id } = file;
    const { onSuccess } = this.props;
    onSuccess && onSuccess(url, id);
  };

  render() {
    const { title, description, type, accept } = this.props;
    const { getIntlMessage } = this.context;
    const { mode } = this.state;
    const mimeType = type === 'pdf' ? 'applicaiton/pdf' : `${type}/*`;
    const fileType = type === 'pdf' ? 'other' : type;
    const toolbar = (
      <Toolbar>
        <TabButton selected={mode === 'upload'} onTouchTap={this.uploadMode}>
          {title}
        </TabButton>
        <TabButton selected={mode === 'library'} onTouchTap={this.libraryMode}>
          {getIntlMessage('menu.mediaLibrary')}
        </TabButton>
      </Toolbar>
    );
    return (
      <Dialog {...this.props}>
        {toolbar}
        <div className={css.container}>
          {mode === 'library' && (
            <FileSelectorContainer onSelect={this.selectFile} type={fileType} />
          )}
          {mode === 'upload' && (
            <FileUploader
              type={mimeType}
              onSuccess={this.uploadSuccess}
              description={description}
            />
          )}
        </div>
      </Dialog>
    );
  }
}

export default UploadDialog;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/UploadDialog.js